<template>
  <div id="screenDisplay">
    <transition name="fade">
      <div class="mask" v-show="showMask" @click="hiddenMask">
        <div class="title">工业经济监测平台</div>
      </div>
    </transition>
    <div class="top">
      <!-- <router-link to="/sinDisplay"> -->
      <router-link to="/newScreen">
        <img src="../../assets/imgs/icon/icon_computer_blue.png" alt />
      </router-link>
      <router-link to="/home">
        <img src="../../assets/imgs/icon/icon_back.png" alt />
      </router-link>
    </div>
    <div class="title">工业经济监测平台</div>
    <div class="timeBox" v-show="false">
      <div class="output">
        <img src="../../assets/imgs/icon/icon_output.png" alt />
      </div>
      <div class="date"></div>
    </div>
    <tab-cut v-if="!showMask" tag="left" current="区域监测" ref="leftContent"></tab-cut>
    <tab-cut v-if="!showMask" tag="right" current="园区监测" ref="rightContent"></tab-cut>
  </div>
</template>
<script>
import TabCut from "@/components/tabCut/tabCut.vue"; //tab切换组件
export default {
  components: {
    "tab-cut": TabCut
  },
  data() {
    return {
      showMask: true
    };
  },
  methods: {
    hiddenMask() {
      this.showMask = false;
    }
  }
};
</script>

<style lang="less" scoped>
#screenDisplay {
  .top {
    position: absolute;
    right: 20px;
    top: 40px;

    img {
      margin-right: 20px;
    }
  }

  .mask {
    width: 5280px;
    height: 1600px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3000;
    background: url(../../assets/imgs/background/screen_bg.gif) center no-repeat;
    background-size: cover;

    .title {
      text-align: center;
      width: 2430px;
      font-size: 80px;
      font-weight: 500;
      line-height: 236px;
      color: #ffffff;
      position: absolute;
      background: url(../../assets/imgs/background/top_title_bg.png) center
        no-repeat;
      background-size: cover;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  padding: 20px 100px 0;
  box-sizing: border-box;
  position: relative;
  width: 5280px;
  height: 1600px;
  display: flex;
  justify-content: space-between;
  background: url(../../assets/imgs/background/screen_bg.png);
  background-size: cover;

  .title {
    text-align: center;
    width: 1215px;
    font-size: 36px;
    font-weight: 500;
    line-height: 118px;
    color: #ffffff;
    position: absolute;
    background: url(../../assets/imgs/background/top_title_bg.png) center
      no-repeat;
    background-size: cover;
    left: 50%;
    top: 90px;
    transform: translateX(-50%);
  }

  .timeBox {
    position: absolute;
    width: 527px;
    height: 46px;
    display: flex;
    right: 150px;
    top: 140px;
    cursor: pointer;
    justify-content: space-between;

    .output {
      width: 130px;
      height: 47px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url(../../assets/imgs/background/out_bg.png) center no-repeat;
      background-size: cover;
    }

    .date {
      width: 395px;
      height: 47px;
      background: url(../../assets/imgs/background/date_bg.png) center no-repeat;
      background-size: cover;
    }
  }
}

.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>